{
  "storyboards": {
    "cmt2vf19r0001jl045xnayplm": {
      "name": "israel-election-poll-tracker",
      "rngsIo": "https://www.rngs.io/storyboards/cmt2vf19r0001jl045xnayplm/",
      "stories": {
        "cmt2vf2290002jl04ykp5hws5": {
          "name": "page-en",
          "rngsIo": "https://www.rngs.io/storyboards/cmt2vf19r0001jl045xnayplm/story/cmt2vf2290002jl04ykp5hws5/",
          "syncPath": "locales/en/content.json"
        },
        "cmt2vf2yr0003jl04cpmpkyn5": {
          "name": "embeds",
          "rngsIo": "https://www.rngs.io/storyboards/cmt2vf19r0001jl045xnayplm/story/cmt2vf2yr0003jl04cpmpkyn5/",
          "syncPath": "locales/en/embeds.json"
        }
      }
    }
  }
}